import React from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import styled from 'styled-components';

const Img = styled.img`
    ${(props) => props.height && `height: ${props.height} !important;`}
    ${(props) => props.width && `width: ${props.width} !important;`}
`;

const ImgContainer = styled.div`
    ${(props) =>
        props.position && `justify-content: ${props.position} !important;`}
`;

const Image = (props) => {
    const history=useHistory();
    const { url, height, width, position, className, classNameContainer, onImageClick, onClickURL } =
        props;

  console.log("window.location.origin" , window.location.origin);
    const handleImageClick = () => {
        console.log('onClickURL:', onClickURL);
        if (onClickURL) {
            // If clickURL is provided, open it in a new tab
            window.open(onClickURL, "_blank");
        } else if (onImageClick) {

            switch (onImageClick) {
                case "OPEN_DEAL":
                    history.push("/deals");
                    break;
                case "OPEN_EVENT":
                    history.push("/events");
                    break;
                case "OPEN_BLOGS":
                    history.push("/blogs");
                    break;
                default:
                    break;
            }
        }
    };

    if (!url) {
        return <div />;
    }

    return (
        <ImgContainer
            className={classNameContainer ? classNameContainer : 'flex'}
            position={position}
        >
            <Img
                height={height}
                width={width}
                className={className || ''}
                src={url}
                onClick={handleImageClick}
            />
        </ImgContainer>
    );
};

export default Image;
